import React from 'react';
import _ from 'lodash';
import Select from 'react-select';

import Api from './Config';

// Ideally, these journey configs should be managed in the DB,
// refactor when we build the application to create journey.
const journey_config = {
  // Workplace Monitoring with Daily Temperature Journey
  15: {
    patient_ref_suffix: 'BTW',
    id_label: 'Your ID#',
  },
  // Lifeline Journey
  24: {
    patient_ref_suffix: 'LFLN',
    id_label: 'Your Enrollment ID',
  },
  // Journey for all with meds Journey
  6: {
    patient_ref_suffix: 'JFAEM',
    id_label: 'Your ID#',
  },
};

export default class AutoAddTCode extends React.Component {
  constructor(props) {
    super(props);
    const nowYear = new Date().getFullYear();
    this.state = {
      employers: [],
      selectedEmployer: null,
      selectedDivision: null,
      selectedEmployerName: '',
      employee_id: '',
      employee_initial: '',
      yob: nowYear - 40,
      gender: '',
      loading: false,
    };

    this.dateRange = _.range(nowYear - 100, nowYear + 1);
  }

  componentDidMount() {
    this.getCompanies();
  }

  getCompanies() {
    const { clubID } = this.props.match.params;

    Api.getAllGroups(clubID)
      .then((item) => {
        const arr = item.data;
        this.setState({ employers: arr });
        if (arr.length > 0) {
          const obj = arr[0];
          this.setState({
            selectedEmployer: obj,
            selectedEmployerName: obj.group_code,
            selectedDivision: obj.divisions[0],
          });
        }
        this.select.focus();
      })
      .catch((err) => {
        console.log(err);
      });
  }

  doEnroll() {
    const { selectedEmployer, employee_id, gender, yob, employee_initial, selectedEmployerName, selectedDivision } =
      this.state;
    const message = { action: 'ALERT', title: 'Error' };
    if (selectedEmployer === null) {
      message.message = 'Please select group.';
    }
    if (employee_id.length < 2) {
      message.message = 'invalid  id';
    }
    if (message.message) {
      window.ReactNativeWebView.postMessage(JSON.stringify(message));
      return;
    }
    this.setState({ loading: true });
    const { JID, DID, clubID } = this.props.match.params;
    const patient_ref_suffix = journey_config[JID] ? journey_config[JID].patient_ref_suffix : '';
    const patient_ref = `${employee_id + employee_initial}-${patient_ref_suffix}`;
    Api.addTCodeAuto(JID, patient_ref, '', yob, gender, {}, selectedEmployerName, 'APP_ADDED', DID, clubID)
      .then(({ RESULT, TCODE }) => {
        if (RESULT === 'SUCCESS') {
          message.action = 'ADDTCODE';
          message.TCODE = TCODE;
          // prevent double tap
          window.ReactNativeWebView.postMessage(JSON.stringify(message));
        } else {
          message.message = 'Something went wrong !!';
          window.ReactNativeWebView.postMessage(JSON.stringify(message));
          this.setState({ loading: false });
        }
      })
      .catch((err) => {
        console.log(err);
        message.message = `${err}`;
        window.ReactNativeWebView.postMessage(JSON.stringify(message));
        this.setState({ loading: false });
      });
  }

  render() {
    return (
      <form>
        <div style={{ marginTop: 10, touchAction: 'none' }} className="container-fluid">
          <h4>Please provide the following details to enroll in your health monitoring journey.</h4>
          <div className="panel panel-default" style={{ margin: 20 }}>
            <div
              className="panel-body"
              style={{
                display: 'flex',
                flexDirection: 'column',
                minHeight: 'min(70vh,500px)',
                justifyContent: 'space-between',
              }}
            >
              <div className="from-group">
                <label>
                  {journey_config[this.props.match.params.JID]
                    ? journey_config[this.props.match.params.JID].id_label
                    : 'Your ID#'}
                </label>
                <input
                  value={this.state.employee_id}
                  onChange={(e) => {
                    const regx = /^[A-Za-z0-9]+$/;
                    const val = `${e.target.value}`;
                    if (val == '' || regx.test(val)) {
                      this.setState({ employee_id: val });
                    }
                  }}
                  size={9}
                  style={{ width: 200 }}
                  type="text"
                  className="form-control"
                />
              </div>
              <div className="form-group">
                {false && <label>Place of Employment</label>}
                {true && <label>Group</label>}

                <select
                  className="form-control"
                  onChange={(e) => {
                    const selected_group_code = e.target.value;
                    const obj = _.find(this.state.employers, (a) => a.group_code == selected_group_code);
                    if (obj != null) {
                      this.setState({
                        selectedEmployer: obj,
                        selectedEmployerName: obj.group_code,
                        selectedDivision: obj.divisions[0],
                      });
                    } else {
                      this.setState({ selectedEmployer: null, selectedEmployerName: '', selectedDivision: null });
                    }
                  }}
                >
                  {this.state.employers.map((emp) => (
                    <option key={emp.group_code} value={emp.group_code}>
                      {emp.group_code}
                    </option>
                  ))}
                </select>

                {false && (
                  <Select
                    onChange={(obj) => {
                      if (obj != null) {
                        this.setState({
                          selectedEmployer: obj,
                          selectedEmployerName: obj.group_code,
                          selectedDivision: obj.divisions[0],
                        });
                      } else {
                        this.setState({ selectedEmployer: null, selectedEmployerName: '', selectedDivision: null });
                      }
                    }}
                    placeholder="select"
                    ref={(ref) => (this.select = ref)}
                    autoFocus
                    value={this.state.selectedEmployer}
                    getOptionLabel={(a) => a.group_code}
                    getOptionValue={(a) => a.id}
                    options={this.state.employers}
                  />
                )}
              </div>

              {this.state.selectedEmployer && this.state.selectedEmployer.divisions.length > 0 && (
                <div className="form-group">
                  <label>Division</label>
                  <select
                    onChange={(e) => {
                      this.setState({ selectedDivision: e.target.value });
                    }}
                    autoFocus
                    ref={(ref) => (this.division_select = ref)}
                    tabIndex={0}
                    className="form-control"
                  >
                    {this.state.selectedEmployer.divisions.map((a) => (
                      <option value={a} key={a}>
                        {a}
                      </option>
                    ))}
                  </select>
                </div>
              )}

              <div className="from-group">
                <label>
                  Your Initials(
                  <span style={{ textDecoration: 'none', fontWeight: 'normal', fontStyle: 'italic' }}>
                    First and Last
                  </span>
                  )
                </label>
                <input
                  ref={(ref) => {
                    this.lastField = ref;
                  }}
                  onChange={(e) => {
                    const regx = /^[A-Za-z0-9]+$/;
                    const val = `${e.target.value}`;
                    if (val == '' || regx.test(val)) {
                      this.setState({ employee_initial: val });
                    }
                  }}
                  value={this.state.employee_initial}
                  onKeyUp={(e) => {
                    if (e.keyCode === 13) {
                      this.lastField.blur();
                    }
                  }}
                  size={9}
                  maxLength={3}
                  style={{ width: 100 }}
                  type="text"
                  className="form-control"
                />
              </div>
              <div className="from-group">
                <label>Year of Birth</label>
                <select
                  style={{ width: 100 }}
                  className="form-control"
                  value={this.state.yob}
                  onChange={(e) => {
                    this.setState({ yob: e.target.value });
                  }}
                >
                  {_.map(this.dateRange, (a) => (
                    <option value={a} key={a}>
                      {a}
                    </option>
                  ))}
                </select>
              </div>

              <div className="from-group">
                <label>Gender</label>
                <select
                  style={{ width: 200 }}
                  className="form-control"
                  value={this.state.gender}
                  onChange={(e) => {
                    this.setState({ gender: e.target.value });
                  }}
                >
                  <option value="NA">Not specified</option>
                  <option value="MALE">Male</option>
                  <option value="FEMALE">Female</option>
                </select>
              </div>
            </div>

            <div className="panel-footer" style={{ display: 'flex', justifyContent: 'space-between' }}>
              <button
                disabled={this.state.loading}
                type="button"
                onClick={() => {
                  this.doEnroll();
                }}
                className="btn btn-success"
                style={{ width: 130 }}
              >
                Enroll
              </button>
              <button
                type="button"
                onClick={() => {
                  const actionObject = { action: 'CLOSE' };
                  window.ReactNativeWebView.postMessage(JSON.stringify(actionObject));
                }}
                className="btn btn-danger"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </form>
    );
  }
}
